import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
//import * as actions from './actionsTypes';
import * as actions from '../relatives/actionsTypes';
import errorManage from '../errorManage';
import gestorDocumentalServices from '../gestorDocumental/gestorDocumental.services';
import { SAVE_LOADER_RELATIVES } from '../relatives/actionsTypes';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const requestChangesDependants = (data, func, edit, dataGD, index, editItem, iType, uploadFile, setShowModal, setValidFechaDoc) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SAVE_LOADER_RELATIVES,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};

    await client.post(`/api/app/Actualizacion_Dependiente/`, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });
    if(uploadFile){
      const { relatives, relativesLength } = getState().relatives;
      dataGD.append("id_registro", parseInt(editItem.id));
      let respGD = null;
      let isNew = false;
      if(edit && editItem.archivos_gestor === null){
        respGD = await gestorDocumentalServices.saveDocument(dataGD);
        isNew = true;
      }else{
        respGD = await gestorDocumentalServices.editDocument(editItem.archivos_gestor, dataGD);
      }
      const respRel = await client.put(iType === 1 ? `/api/app/Formal_Dependientes_Economico/${editItem.id}/` : `/api/app/Funcional_Dependientes_Economico/${editItem.id}/`, {
        ...editItem,
        archivos_gestor: isNew ? respGD.data.resultado.id : respGD.data.id
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
      }});
      relatives[index] = respRel.data;
      dispatch({
        type: actions.GET_RELATIVES,
        payload: {
          relatives: relatives,
          relativesLength: relativesLength
        }
      });
    }
    func(true);
    if(setShowModal){
      setShowModal(false);
    }
    if(setValidFechaDoc){
      setValidFechaDoc(false);
    }
  } catch (ex) {
    console.log(ex);
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: SAVE_LOADER_RELATIVES,
      payload: false
    });
  }
}